export function MenuOverlay() {

  var mediaQuery = window.matchMedia("(max-width: 576px)")

  $('.menu-parent.menu-item-has-children > a').on("mouseenter click", function(e) {
    if (!$(this).parent().hasClass('open-menu')) {
      $(this).parent().toggleClass('open-menu');
      e.stopPropagation();
      e.preventDefault();
    }
  });
  $('.menu-parent.menu-item-has-children').on("mouseleave", function(e) {
    if (mediaQuery.matches) {
    } else {
      if ($(this).hasClass('open-menu')) $(this).toggleClass('open-menu');
    }
  });
  
  //toggle mobile arrows
  $('.menu-parent.menu-item-has-children > .child-list-mobile').on("click", function(e) {
    $(this).toggleClass('child-list-mobile-open');
    if ($(this).hasClass('child-list-mobile-open')) {
      $(this).parent().toggleClass('open-menu');
      e.stopPropagation();
      e.preventDefault();
    }else{
      $(this).parent().toggleClass('open-menu');
    }
  });
}
